/* @flow */
import * as React from 'react';
import PropTypes from 'prop-types';
import QuickPromotionAppOpenedModals from 'components/QuickPromotionAppOpenedModals.jsx';
import BannersContainer from 'components/banners/BannersContainer.jsx';
import ProfileCompletenessModals from 'user/components/ProfileCompletenessModals.jsx';
import MergeSisAccountsModals from 'organizations/components/MergeSisAccountsModals.jsx';
import AppboyPreaskModal from 'app/components/AppboyPreaskModal.jsx';
import User from 'entities/User';

import { markSeenClasses } from 'utils/accountCompletionTracker';
import { unauthorizedInterceptor } from 'lib/ResponseInterceptors';

import { registerInterceptor, unregisterInterceptor } from 'singletons/xhrInterceptors';

type Props = {
  user: ?User,
  children?: ?any,
  location: {
    query: {
      email_token?: ?string,
    },
  },
};

class AppLayout extends React.Component<Props> {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  componentDidMount() {
    registerInterceptor('401-interceptor', unauthorizedInterceptor);
    const { user } = this.props;
    if (user) {
      // XXX this component isn't the /classes list
      markSeenClasses(user);
    }
  }

  componentWillUnmount() {
    unregisterInterceptor('401-interceptor');
  }

  render() {
    const shouldShowBanner = this.props.user && !this.context.router.isActive('/setup');
    const emailToken = this.props.location.query.email_token;

    return (
      <div style={{ height: '100%' }}>
        {shouldShowBanner && <BannersContainer data-test="banners-container" />}
        {this.props.children}
        {emailToken && <MergeSisAccountsModals emailToken={emailToken} />}
        <QuickPromotionAppOpenedModals />
        <ProfileCompletenessModals />
        {this.props.user && <AppboyPreaskModal />}
      </div>
    );
  }
}

export default AppLayout;
